import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import Modals from "../../../components/modal";
import DeleteConfirmation from "../../../components/delete-confirmation";
import { useDeletePlan } from "./hooks";
import { useUser } from "./../../../common-hooks/user";
const DeletePlan = ({ plan }) => {
  const {
    handleDeletePlan,
    isOpenModal,
    toggleModal,
    deletePlanLoading,
  } = useDeletePlan(plan);

  const { isAdmin } = useUser();

  if (!isAdmin) {
    return null
  }

  return (
    <>
      <Tooltip title="Delete" placement="bottom">
        <i
          className={`fa fa-trash icon-btn-action text-danger `}
          onClick={toggleModal}
        ></i>
      </Tooltip>
      {isOpenModal ? (
        <Modals
          isOpenModal
          setIsOpenModal={toggleModal}
          message={
            <DeleteConfirmation
              message="Are you sure you want to delete?"
              handleDelete={handleDeletePlan}
              isLoading={deletePlanLoading}
            />
          }
          title="Delete Plan"
        />
      ) : null}
    </>
  );
};

export default DeletePlan;
